import styles from '@/styles/Info.module.scss'
import BaseLayout from '@/layout/BaseLayout/BaseLayout'
import Head from 'next/head'
import React from 'react'
import { GetStaticProps } from 'next'
import { serverSideTranslations } from 'next-i18next/serverSideTranslations'
import { useTranslation } from 'next-i18next'
import Hero from '@/components/common/Hero/Hero'
import ContactForm from '@/components/common/ContactForm/ContactForm'
import classNames from 'classnames'
import PhoneIcon from '@/assets/svg/phone.svg'
import SendIcon from '@/assets/svg/send.svg'
import Raw from '@/components/common/Raw/Raw'
import { getPageTitle } from '@/utils/helpers'
import ContactInfo from '@/components/common/ContactInfo/ContactInfo'

type Props = {}

const About = (props: Props) => {
  const { t } = useTranslation('about')

  return (
    <BaseLayout>
      <Head>
        <title>{getPageTitle(t('title'))}</title>
      </Head>
      <Hero />
      <main className={classNames(styles.info, styles.split)}>
        <div>
          <div>
            <h1>{t('aboutUs')}</h1>
            <Raw content={t('aboutUsText')} />
            <div>
              <h3>{t('companyInformation')}:</h3>
              <p>
                Statusfälgar i Sverige AB<br />
                Arkitektvägen 4<br />
                14945 Nynäshamn, Sverige<br />
                Organisationsnummer: 559329-8051<br />
                VAT nr: SE559329805101<br />
              </p>
            </div>
          </div>
          <ContactInfo />
        </div>
        <div>
          <ContactForm />
        </div>
      </main>
    </BaseLayout>
  )
}

export default About

export const getStaticProps: GetStaticProps<Props> = async ({
  locale,
}) => ({
  props: {
    ...(await serverSideTranslations(locale ?? 'en', [
      'common',
      'about',
      'footer'
    ])),
  },
})